import styled from '@emotion/styled';
import { Box, Button, FormControl, Stack } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers';

export const StyledDayButton = styled(Button)(({ theme, selected }) => ({
  borderRadius: '20px',
  //   width: '87px',
  //   height: '91px',
  minWidth: 'unset',
  padding: '11.5px 15px',
  height: 'fit-content',
  border: selected ? 'unset' : `1px solid ${theme.palette.blue.button}`,
  backgroundImage: selected
    ? 'linear-gradient(90deg, #014D6C 0%, #014D6C 6.25%, #014E6D 12.5%, #01506E 18.75%, #015270 25%, #025573 31.25%, #025975 37.5%, #025D79 43.75%, #03627D 50%, #036781 56.25%, #046D86 62.5%, #04748C 68.75%, #057C92 75%, #068498 81.25%, #068D9F 87.5%, #0796A7 93.75%, #08A0AF 100%)'
    : '',
  flexDirection: 'column',
  rowGap: '14px',
  transition: 'all 0.4s ease',

  p: {
    backgroundColor: selected ? 'transparent' : '',
    color: selected ? theme.palette.white.main : theme.palette.blue.dark,
    fontSize: '22px',
    fontWeight: 500,
    lineHeight: 1.1,
    transition: 'all 0.4s ease',
  },

  '&:hover': {
    border: 'unset',
    backgroundImage:
      'linear-gradient(90deg, #014D6C 0%, #014D6C 6.25%, #014E6D 12.5%, #01506E 18.75%, #015270 25%, #025573 31.25%, #025975 37.5%, #025D79 43.75%, #03627D 50%, #036781 56.25%, #046D86 62.5%, #04748C 68.75%, #057C92 75%, #068498 81.25%, #068D9F 87.5%, #0796A7 93.75%, #08A0AF 100%)',
    backgroundColor: 'transparent',

    p: {
      color: theme.palette.white.main,
    },
  },
}));

export const StyledTimeSelect = styled('select')(({ theme }) => ({
  borderRadius: '8px',
  backgroundColor: 'rgba(218, 241, 243, 1)',
  border: 'unset',
  WebkitAppearance: 'none',
  outline: 'none',
  fontSize: '16px',
  fontWeight: 700,
  color: theme.palette.blue.dark,
  lineHeight: '1.25',
  padding: '8px',

  option: {
    fontSize: '16px',
    fontWeight: 700,
    color: theme.palette.blue.dark,
  },
}));

export const StyledCarSelect = styled(FormControl)(({ theme, width }) => ({
  width: width,

  '> div': {
    height: '70px',
    borderRadius: '8px',
    backgroundColor: 'white',
    boxShadow: '0px 0px 6px 0px rgba(1, 77, 108, 0.07)',

    fieldset: {
      border: `1px solid ${theme.palette.blue.main}`,
    },
  },
}));

export const StyledCarEmployeesWrapper = styled(Box)(({ theme }) => ({
  padding: '10px',
  border: `1px solid ${theme.palette.blue.light}`,
  borderRadius: 16,
}));

export const StyledEmployeesWrapper = styled(Stack)(({ theme }) => ({
  padding: '10px',
  border: `1px solid ${theme.palette.blue.main}`,
  borderRadius: 16,
  backgroundColor: 'rgba(245, 248, 249, 1)',
}));

export const StyledCondition = styled(Stack)(({ theme, selected = false }) => ({
  paddingInline: '10px',
  borderRadius: 50,
  border: selected
    ? '1px solid rgba(179, 244, 222, 1)'
    : `1px solid ${theme.palette.blue.main}`,
  backgroundColor: selected
    ? theme.palette.green.shine
    : theme.palette.blue.light,
  color: selected ? theme.palette.green.dark : theme.palette.blue.dark,
}));
